import { FormControl } from '@common/components/form-control';
import cx from 'classnames';
import { I18n } from 'react-redux-i18n';

import { Flex } from '@common/components/Flex';
import { MODULE_NAME, DATE_TYPE } from '../../../../audit-report';
import { formatDate } from '@common/utils/date';

import './dates.styles.scss';

export const Dates = (props) => {
  const { className, value, onChange } = props;

  const handleDateChange = React.useCallback((e) => {
    e.persist();

    const { value: selectedDate, dataset: { type } } = e.currentTarget;

    onChange({
      ...value,
      [type]: {
        ...value[type],
        value: selectedDate,
      }
    });
  }, [value, onChange]);

  const handleUseStatusChange = React.useCallback((e) => {
    e.persist();

    const { dataset: { type } } = e.currentTarget;
    const isChecked = !value[type].use;

    onChange({
      ...value,
      [type]: {
        ...value[type],
        value: isChecked ? formatDate(new Date(), { format: 'YYYY-MM-DD' }) : '',
        use: isChecked,
      }
    });
  }, [value, onChange]);

  const config = [
    {
      type: DATE_TYPE.start,
      label: 'Show Records From:',
    },
    {
      type: DATE_TYPE.end,
      label: 'To:',
    },
  ];

  return (
    <Flex className={cx('FieldAuditReportDates', className)} alignItems="center">
      {config.map(({ label, type }) => (
        <React.Fragment key={label}>
          <span className="FieldAuditReportDates__label">
            {I18n.t(label)}
          </span>
          <div className="FieldAuditReportDates__date">
            <input 
              id={`${MODULE_NAME}-filter-${type}-date-use`}
              className="FieldAuditReportDates__date__checkbox" 
              type="checkbox" 
              data-type={type}
              checked={value[type].use} 
              onChange={handleUseStatusChange} 
            />
            <FormControl
              disabled={!value[type].use} 
              className={cx('FieldAuditReportDates__date__date-picker', { 'FieldAuditReportDates__date__date-picker--disabled': !value[type].use })}
              type="date" 
              value={value[type].value}
              data-type={type}
              id={`${MODULE_NAME}-filter-${type}-date`}
              onChange={handleDateChange}
            />
          </div>
        </React.Fragment>
      ))}
    </Flex>
  );
};